export const Loader = () => <div className="loader"></div>;
